import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import MobileDownloadPage from "../pages/MobileDownload/MobileDownloadPage";
import { DASHBOARD_PAGE, MODULE_SELECTOR_PAGE, MOBILE_DOWNLOAD_PAGE, PRAMETRAGE_PAGE, VVINAL_PAGE, DATABASE_VEHICULE_MANAGER_PAGE, DATABASE_VEHICULE_PAGE, DATABASE_CLIENT_PAGE, DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_EDIT, DATABASE_CLIENT_FORM, DATABASE_CLIENT_EDIT, ENCHERES_PAGE, VHU_LOTS_PAGE, VHU_EXPIRED_LOTS_PAGE, VHU_LOT_FORM, VHU_LOT_EDIT, VHU_BID_OFFERS_PAGE, FERRAILLEURS_ENCHERES_VISIBLES_PAGE, FERRAILLEURS_MES_ACHATS_PAGE, FERRAILLEURS_TERMS_PAGE, RESEAU_PAGE  } from "./routeConstants";
import ParametragePage from "../modules/parametrage/index";
import VVinalPage from "../modules/valeurVinal/vVinalPage";
import VehiculePage from "../modules/database/VehiculePage";
import VehiculeManagerPage from "../modules/database/VehiculeManagerPage";
import ClientPage from "../modules/database/ClientPage";
import VehiculeForm from "../modules/database/VehiculeForm";
import ClientForm from "../modules/database/ClientForm";
import ModuleSelectorPage from "../modules/moduleSelector/ModuleSelectorPage";
import VhuLotsAdminPage from "../modules/vhu/VhuLotsAdminPage";
import VhuExpiredLotsPage from "../modules/vhu/VhuExpiredLotsPage";
import VhuLotFormPage from "../modules/vhu/VhuLotFormPage";
import VhuBidOffersPage from "../modules/vhu/VhuBidOffersPage";
import FerrailleurEncheresVisiblesPage from "../modules/ferrailleurs/FerrailleurEncheresVisiblesPage";
import MesAchatsPage from "../modules/ferrailleurs/MesAchatsPage";
import TermesConditionsPage from "../modules/ferrailleurs/TermesConditionsPage";
import ReseauPage from "../modules/reseau/ReseauPage";
import { ASSURANCE_ROLES, EXPERT_ROLES, FERRAILLEUR_ROLES } from "../helpers/roles";


const authProtectedRoutes = [
    { path: MODULE_SELECTOR_PAGE, component: <ModuleSelectorPage />, withoutLayout: true },
    { path: DASHBOARD_PAGE, component: <VehiculePage />, roles: [...EXPERT_ROLES, ...ASSURANCE_ROLES] },
    { path: DATABASE_VEHICULE_MANAGER_PAGE, component: <VehiculeManagerPage />, roles: EXPERT_ROLES },

	{ path: DATABASE_VEHICULE_PAGE, component: < VehiculePage/>, roles: [...EXPERT_ROLES, ...ASSURANCE_ROLES] },
	{ path: DATABASE_VEHICULE_FORM, component: <Navigate to={DATABASE_VEHICULE_MANAGER_PAGE} />, roles: EXPERT_ROLES },
	{ path: DATABASE_VEHICULE_EDIT, component: <VehiculeForm />, roles: EXPERT_ROLES },

	{ path: DATABASE_CLIENT_PAGE, component: < ClientPage/>, roles: [...EXPERT_ROLES, ...ASSURANCE_ROLES] },
	{ path: DATABASE_CLIENT_FORM, component: <ClientForm />, roles: EXPERT_ROLES },
	{ path: DATABASE_CLIENT_EDIT, component: <ClientForm />, roles: EXPERT_ROLES },	

    { path: VVINAL_PAGE, component: <VVinalPage />, roles: EXPERT_ROLES },
    { path: PRAMETRAGE_PAGE, component: <ParametragePage />, roles: EXPERT_ROLES },
    { path: ENCHERES_PAGE, component: <Navigate to={VHU_LOTS_PAGE} />, roles: EXPERT_ROLES },
    { path: VHU_LOT_FORM, component: <VhuLotFormPage />, roles: EXPERT_ROLES },
    { path: VHU_LOT_EDIT, component: <VhuLotFormPage />, roles: EXPERT_ROLES },
    { path: VHU_LOTS_PAGE, component: <VhuLotsAdminPage />, roles: EXPERT_ROLES },
    { path: VHU_EXPIRED_LOTS_PAGE, component: <VhuExpiredLotsPage />, roles: EXPERT_ROLES },
    { path: VHU_BID_OFFERS_PAGE, component: <VhuBidOffersPage />, roles: EXPERT_ROLES },
    { path: FERRAILLEURS_ENCHERES_VISIBLES_PAGE, component: <FerrailleurEncheresVisiblesPage />, roles: FERRAILLEUR_ROLES },
    { path: FERRAILLEURS_MES_ACHATS_PAGE, component: <MesAchatsPage />, roles: FERRAILLEUR_ROLES },
    { path: FERRAILLEURS_TERMS_PAGE, component: <TermesConditionsPage />, roles: FERRAILLEUR_ROLES },
    { path: RESEAU_PAGE, component: <ReseauPage />, roles: EXPERT_ROLES },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: <Navigate to={MODULE_SELECTOR_PAGE} />, withoutLayout: true },
];

const publicRoutes = [
	{ path: MOBILE_DOWNLOAD_PAGE, component: <MobileDownloadPage /> },
	{ path: "/mobile", component: <MobileDownloadPage /> },
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
];

export { authProtectedRoutes, publicRoutes };
